const convertToTitleCase = (input: string | string[] | undefined) => {
  // If input is undefined or empty, return an empty string
  if (!input || (Array.isArray(input) && input.length === 0)) {
    return '';
  }

  // Convert single string input to an array with a single element
  const names = typeof input === 'string' ? [input] : input;

  // Apply title case conversion to each element of the array
  const titleCaseNames = names.map((name) => {
    const firstChar = name?.[0];
    if (!name || !firstChar) {
      return '';
    }
    return firstChar.toUpperCase() + name.slice(1).toLowerCase();
  });

  // Join the title case names into a single string using a space as a separator
  return titleCaseNames.join(' ');
};

export default convertToTitleCase;
